module.exports = __webpack_public_path__ + "static/img/room_12.40584cee.png";